import React, { useState } from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle2 } from 'lucide-react';
import { UpsellModal } from './UpsellModal';
export function FinalCTASection() {
  const checkoutUrl = 'https://pay.hotmart.com/F104765975P?checkoutMode=10';
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);
  return <section className="py-16 md:py-24 px-4 bg-forest text-white relative" data-id="element-69" data-mp="uk0s39ozext">
      <div className="max-w-3xl mx-auto text-center" data-id="element-70" data-mp="2zea32dvwd1bk">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-gold mb-8" data-id="element-71" data-mp="2zbe7uxbfoqqt">
          Es Tu Momento
        </h2>

        <div className="space-y-4 text-lg md:text-xl text-cream/90 mb-12" data-id="element-72" data-mp="39bogs5qfrc06">
          <p data-id="element-73" data-mp="399llp7afesol">
            Durante demasiado tiempo has buscado la solución en lo que comes al
            mediodía.
          </p>
          <p className="font-bold text-white" data-id="element-74" data-mp="2gn94hqyov7sj">
            La solución siempre estuvo en lo que comes de noche.
          </p>
          <p data-id="element-75" data-mp="2ll2bunbqa7ue">
            Tienes el método ahora mismo. A $26.499 ARS. Con garantía total de
            30 días.
          </p>
          <p className="italic text-gold" data-id="element-76" data-mp="26u92pnbtgwbg">
            No hay razón para esperar una semana más. Una noche más. Un espejo
            más.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-10 shadow-2xl text-dark max-w-xl mx-auto" data-id="element-77" data-mp="1x460qxmpw80z">
          <div className="mb-6" data-id="element-78" data-mp="1s6wbpj38pydo">
            <p className="text-sm font-bold text-urgency uppercase tracking-wider mb-2" data-id="element-79" data-mp="1s5usgrc2m5kv">
              Precio de Lanzamiento
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-80" data-mp="1j5puf7srojjd">
              <span className="text-2xl text-dark/40 line-through font-bold" data-id="element-81" data-mp="1j7j4yy6i3nwn">
                $54.696
              </span>
              <span className="text-5xl font-serif font-bold text-forest" data-id="element-82" data-mp="197ig6wpv4fl2">
                $26.499 <span className="text-xl" data-id="element-83" data-mp="199mveat7p10n">ARS</span>
              </span>
            </div>
          </div>

          <CTAButton text="OBTENER MI PROTOCOLO AHORA" onClick={() => setIsUpsellOpen(true)} variant="primary" className="text-xl py-4 mb-6" data-id="element-84" data-mp="33l9yekm9c7s4" />

          <div className="text-sm text-dark/70 space-y-2 text-left bg-cream p-4 rounded-xl" data-id="element-85" data-mp="16mu9d9k2zcnm">
            <p className="font-bold text-center mb-2 text-forest" data-id="element-86" data-mp="rxy2vgxoa7p4">
              ¿Aún tienes dudas? Recuerda:
            </p>
            <div className="grid grid-cols-1 gap-2" data-id="element-87" data-mp="wwhqrmvtttk4">
              <p className="flex items-center gap-2" data-id="element-88" data-mp="wuya3v69dght">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-89" data-mp="1kmbyxr57aty1" />{' '}
                Garantía completa de 30 días
              </p>
              <p className="flex items-center gap-2" data-id="element-90" data-mp="1pjlza1u4oq0n">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-91" data-mp="1bmp27inf2cbb" />{' '}
                Acceso inmediato tras la compra
              </p>
              <p className="flex items-center gap-2" data-id="element-92" data-mp="1fpll7agvcafs">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-93" data-mp="5p8qjpc1rfp" /> 15
                minutos por noche es todo lo que necesitas
              </p>
              <p className="flex items-center gap-2" data-id="element-94" data-mp="460trxllxtrp">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-95" data-mp="3ssxeoapczxi7" />{' '}
                Diseñado para mujeres de más de 35 años
              </p>
            </div>
          </div>

          <p className="text-xs text-dark/50 mt-6 italic" data-id="element-96" data-mp="6lz5xetzow0u">
            Al completar tu compra recibirás acceso inmediato a todos los
            materiales en formato digital PDF. Compatible con todos los
            dispositivos.
          </p>
        </div>

        <div className="mt-12 text-cream/80 text-lg" data-id="element-97" data-mp="354nyppetu3yz">
          <p className="font-bold text-white mb-2" data-id="element-98" data-mp="355yyzf92ctlc">
            La única decisión equivocada es no tomar ninguna.
          </p>
          <p data-id="element-99" data-mp="3jvn4ksoa2eev">Tu cuerpo lleva tiempo pidiéndote esto.</p>
          <p data-id="element-100" data-mp="3f1smtus8g9if">Esta noche puedes empezar a escucharlo.</p>
        </div>
      </div>

      <UpsellModal isOpen={isUpsellOpen} onClose={() => setIsUpsellOpen(false)} baseCheckoutUrl={checkoutUrl} data-id="element-101" data-mp="2rcptvqs5eu8m" />
    </section>;
}